/* global angular, TimelineMax, TweenMax, $, Expo, _ */
angular.module('ua5App')
    .directive('posts', ['$timeout', '$rootScope', 'TRANSITION', '$state', 'BREAKPOINTS', 'PostFactory', '$sce', function($timeout, $rootScope, TRANSITION, $state, BREAKPOINTS, PostFactory, $sce) {
        return {
            restrict: 'A',
            templateUrl: 'components/posts/posts.html',
            scope: {
                postsData: '=',
                postFilters: '='
            },
            link: function($scope, element, attrs) {
                var currentState = null;
                var lastState = null;
                var isMobile = $(window).width() <= BREAKPOINTS.MOBILE;

                $scope.isSmall = false;
                $scope.smallPosition = 'left';

                $scope.currentFilters = $.extend({}, $scope.postFilters);

                $timeout(function() {
                    var $$element;
                    var timeline;
                    var filters;
                    var page;
                    $$element = $(element);
                    timeline = new TimelineMax({
                        useFrames: true
                    });

                    function setupTimeline(stateName) {
                        var stateDetails = TRANSITION.STATEDETAILS[stateName];
                        var GOLD = '#1b4581';
                        // Header + subheader
                        var WIDTH = 180;
                        var topOffset;
                        var $$back = $$element.find('.posts__back');
                        var $$category = $$element.find('.post__category');
                        var $$program = $$element.find('.post__program');
                        var $$info = $$element.find('.post__info-wrap');
                        var $$post = $$element.find('[post]');
                        var $$filters = $$element.find('.posts__filter-wrap');
                        var $$postMedia = $$element.find('.post__media-container');
                        var $$postMediaImg = $$element.find('.post__media-container__media');
                        var $$whiteout = $$element.find('.post__media-container__whiteout');
                        var $$socialShare = $$element.find('.posts__social-share');
                        var duration;
                        var windowHeight = $(window).outerHeight();
                        var windowWidth = $(window).outerWidth();

                        topOffset = $('body').css('paddingTop');
                        isMobile = $(window).width() <= BREAKPOINTS.MOBILE;

                        // Start fresh
                        timeline.clear();
                        if (isMobile) {
                            duration = 0;
                        } else {
                            duration = TRANSITION.DUR;
                        }

                        function goToHome() {

                            function arrivedHome() {

                                $scope.isSmall = false;
                                $scope.$apply();

                                setTimeout(function() {
                                    TweenMax.set(element, {
                                        clearProps: 'all'
                                    });
                                    TweenMax.set($$postMedia, {
                                        clearProps: 'all'
                                    });
                                    TweenMax.set($$filters, {
                                        clearProps: 'all'
                                    });
                                    TweenMax.set($$whiteout, {
                                        clearProps: 'all'
                                    });
                                    TweenMax.set($$category, {
                                        clearProps: 'all'
                                    });
                                    TweenMax.set($$post, {
                                        clearProps: 'all'
                                    });
                                    TweenMax.set($$program, {
                                        clearProps: 'all'
                                    });
                                    TweenMax.set($$info, {
                                        clearProps: 'all'
                                    });
                                    TweenMax.set($$back, {
                                        clearProps: 'all'
                                    });
                                    TweenMax.set($$socialShare, {
                                        clearProps: 'all'
                                    });
                                }, 100);

                                $('.posts__content > div').show();

                                $rootScope.$broadcast('returnedHome');
                            }

                            if (isMobile) {
                                arrivedHome();
                                return;
                            }

                            timeline
                                .add('scene1', 0) // fade out cat and info
                                .add('scene2', 16) // start moving to sidebar
                                .add('scene3', 36) // start fading in back button
                                // Fade in category and info at the same rate
                                .to($$category, 14 * 2, {
                                    alpha: 1,
                                    ease: Expo.easeInOut
                                }, 'scene3')
                                .to($$postMediaImg, 14 * 2, {
                                    alpha: 1,
                                    ease: Expo.easeInOut
                                }, 'scene3')
                                .to($$postMedia, 14 * 2, {
                                    y: 0
                                }, 'scene3')
                                .to($$program, 14 * 2, {
                                    alpha: 1,
                                    ease: Expo.easeInOut
                                }, 'scene3')
                                .to($$post, 14 * 2, {
                                    paddingLeft: 18,
                                    ease: Expo.easeInOut
                                }, 'scene3')
                                .set(element, {
                                    position: 'relative'
                                }, 'scene2')
                                .fromTo(element, 37 * 2, {
                                    height: windowHeight,
                                    width: WIDTH,
                                    position: 'fixed'
                                }, {
                                    backgroundColor: 'rgba(255,255,255,0)',
                                    paddingLeft: 84,
                                    paddingRight: 84,
                                    paddingTop: topOffset,
                                    left: 0,
                                    marginLeft: 0,
                                    width: windowWidth,
                                    height: windowHeight + 200,
                                    //top: topOffset,
                                    zIndex: 3,
                                    ease: Expo.easeInOut
                                }, 'scene2')
                                .to($$whiteout, 30 * 2, {
                                    alpha: 0,
                                    ease: Expo.easeInOut
                                }, 'scene2')
                                .to($$postMedia, 37 * 2, {
                                    marginBottom: 0,
                                    ease: Expo.easeInOut
                                }, 'scene2')
                                .to($$info, 14 * 2, {
                                    height: 'auto',
                                    opacity: 1
                                }, 'scene2+=74')
                                .to($$filters, 14 * 2, {
                                    alpha: 1,
                                    display: 'block',
                                    ease: Expo.easeInOut
                                }, 'scene2+=74')
                                // Fade out back button
                                .to($$back, 12 * 2, {
                                    alpha: 0,
                                    display: 'none',
                                    ease: Expo.easeInOut
                                }, 'scene1')
                                .to($$socialShare, 12 * 2, {
                                    alpha: 0,
                                    display: 'none',
                                    ease: Expo.easeInOut
                                }, 'scene1')
                                .eventCallback('onComplete', arrivedHome)
                            ;

                        }

                        function goToSide(barPosition, barMarginLeft) {

                            var timeOffset = ($(window).scrollTop() > 1000) ? 20 : 0;

                            if (!$scope.isSmall) {

                                if (typeof $scope.isSmall === 'undefined' && $rootScope.$state.name !== 'home') {
                                    // first load page on side page
                                    $scope.isSmall = true;
                                    $scope.$apply();
                                }

                                //coming from home, that means posts are big right now

                                timeline.set(element, {
                                    height: $$element.outerHeight(),
                                    paddingTop: topOffset,
                                    position: 'fixed',
                                    top: -$(window).scrollTop(),
                                    width: $$element.outerWidth() + $$element.offset().left
                                });

                                timeline
                                    .add('scene0', 0)
                                    .add('scene1', timeOffset + 4) // fade out cat and info
                                    .add('scene2', timeOffset + 20) // start moving to sidebar
                                    .add('scene3', timeOffset + 46) // start fading in back button
                                    // Fade out category and info at the same rate
                                    .to(element, timeOffset, {
                                        top: 0,
                                        onComplete: function() {
                                            $('.posts__content > div:gt(24)').hide();
                                        }
                                    }, 'scene0')
                                    .to($$category, 28, {
                                        alpha: 0,
                                        ease: Expo.easeInOut
                                    }, 'scene1')
                                    .to($$program, 28, {
                                        alpha: 0,
                                        ease: Expo.easeInOut
                                    }, 'scene1')
                                    .to($$postMedia, 28, {
                                        alpha: 1,
                                        y: 0
                                    }, 'scene1')
                                    .to($$postMediaImg, 28, {
                                        alpha: 0
                                    }, 'scene1')
                                    .to($$filters, 28, {
                                        alpha: 0,
                                        display: 'none',
                                        ease: Expo.easeInOut
                                    }, 'scene1')
                                    .to($$info, 14 * 2, {
                                        alpha: 0,
                                        ease: Expo.easeInOut,
                                        onComplete: function() {
                                            $scope.isSmall = true;
                                            $scope.$apply();
                                        }
                                    }, 'scene2')
                                    // Animate to sidebar and fade in whiteout
                                    .to(element, 30 * 2, {
                                        left: barPosition,
                                        marginLeft: barMarginLeft,
                                        backgroundColor: GOLD,
                                        height: '100%',
                                        paddingLeft: 0,
                                        paddingRight: 0,
                                        paddingTop: 71,
                                        width: WIDTH,
                                        zIndex: 1000,
                                        ease: Expo.easeInOut
                                    }, 'scene2')
                                    .set($$postMedia, {
                                        marginBottom: 0
                                    }, 'scene2')
                                    .to($$postMedia, 37 * 2, {
                                        marginBottom: 9,
                                        ease: Expo.easeInOut
                                    }, 'scene2')
                                    .to($$info, 37 * 2, {
                                        height: 47,
                                        //display: 'none',
                                        ease: Expo.easeInOut
                                    }, 'scene2')
                                    // Fade in back button
                                    .to($$back, 66, {
                                        alpha: 1,
                                        display: 'block',
                                        ease: Expo.easeInOut
                                    }, 'scene3')
                                    .to($$socialShare, 20 * 2, {
                                        alpha: 1,
                                        display: 'block',
                                        ease: Expo.easeInOut
                                    }, 'scene2+=74')
                                    .eventCallback('onComplete', function() {
                                        $scope.isSmall = true;
                                        $scope.$apply();
                                    })
                                ;

                            } else {

                                //bar going from side to side

                                timeline
                                    .add('scene1', 0)
                                    .to(element, 5, {
                                        opacity: 0.5
                                    }, 'scene1')
                                    .to(element, 37 * 2, {
                                        opacity: 1,
                                        left: barPosition,
                                        marginLeft: barMarginLeft,
                                        ease: Expo.easeInOut
                                    }, 'scene1+=5')
                                    .eventCallback('onComplete', function() {
                                        $scope.isSmall = true;
                                        $scope.$apply();
                                    })
                                ;
                            }

                        }

                        function goToLeft() {
                            goToSide(0, 0);
                            $scope.smallPosition = 'left';
                        }

                        function goToRight() {
                            goToSide('100%', -WIDTH);
                            $scope.smallPosition = 'right';
                        }

                        if (stateDetails && stateDetails.position && stateDetails.position === 'left') {
                            goToRight();

                        } else if (stateDetails && stateDetails.position && stateDetails.position === 'right') {
                            goToLeft();
                        } else if (stateName === 'home') {
                            goToHome();
                        }

                    }

                    function setOnRight(stateName) {
                        if (TRANSITION.STATEDETAILS[stateName]) {
                            $scope.onRight = TRANSITION.STATEDETAILS[stateName].position === 'left' ? true : false;
                        }
                    }
                    // Animate the size of the element on `$stateChangeStart`.
                    // Make larger if leaving one of the `TRANSITION.STATES`. Make
                    // smaller if entering one
                    $scope.$on('$stateChangeStart', function(e, toState) {
                        var name = toState.name;
                        setOnRight(name);

                        if (name !== 'home') {
                            // this is to hide posts on mobile
                            $('.home__posts').addClass('notInHome');
                        } else {

                            if ($(window).width() <= BREAKPOINTS.MOBILE) {
                                $('.home__posts').removeClass('notInHome');
                                $scope.isSmall = false;
                                $scope.$apply();
                            }
                        }

                        if (currentState !== name) {
                            lastState = currentState;
                            currentState = name;

                            setupTimeline(name);
                            if ($(window).width() > BREAKPOINTS.MOBILE) {
                                timeline.play();
                            }
                        }
                    });

                    $scope.$on('$stateChangeSuccess', function(e, toState) {

                        var duration = TRANSITION.DUR;

                        isMobile = $(window).width() <= BREAKPOINTS.MOBILE;

                        if (isMobile) {
                            duration = 0;
                        }

                        if (toState.name === 'home') {
                            $timeout(function() {
                                // this is to show posts on mobile if home
                                $('.home__posts').removeClass('notInHome');
                                // Enable infinite scroll if on the homepage.
                                $scope.disableInfiniteScroll = false;
                            }, duration * 1000);
                        } else {
                            // Disable infinite scroll if not on the homepage
                            $scope.disableInfiniteScroll = true;
                        }
                    });

                    $scope.$on('childStateLoaded', function(e, toState) {
                        var name;
                        name = toState.name;
                        setOnRight(name);
                        // this should only run once onload to get the initial state
                        if (currentState) {
                            return;
                        }
                        if (TRANSITION.STATES.indexOf(name) > -1 && (currentState !== name)) {
                            currentState = name;
                            setupTimeline(name);
                            timeline.play();
                        }
                        if (name === 'home') {
                            $('.home__posts').removeClass('notInHome');
                        } else {

                            $('.home__posts').addClass('notInHome');
                        }
                    });
                    $timeout(function() {
                        $rootScope.$broadcast('stateRequested');
                    });

                    $scope.$watch('postsData', function(newValue, oldValue) {
                        if (newValue) {
                            $rootScope.$broadcast('posts:loaded');
                            $rootScope.$broadcast('returnedHome');
                        }
                    });
                    // Always start on page 1
                    page = 1;
                    filters = {};

                    if ($state.current.name !== 'home') {
                        // Disable infinite scroll if not on the homepage
                        $scope.disableInfiniteScroll = true;
                    }

                    $scope.$on('postFilterChange', function(e, f) {
                        // Enable infiinte sroll again
                        $scope.disableInfiniteScroll = false;
                        filters = _.clone(f);
                        // Reset page
                        page = 1;
                    });

                    filters = _.clone($scope.postFilters);
                    page = 1;
                    $scope.getMorePosts = function() {
                        // Called by inifinite scroll plugin when user nears
                        // the bottom of the page.
                        filters.page = page += 1;
                        if (!$scope.disableInfiniteScroll) {
                            // As long infinite scroll is still enabled, get
                            // the next set of posts.
                            $scope.disableInfiniteScroll = true;
                            PostFactory.posts().query(filters, function(posts) {
                                if (posts.length > 0) {
                                    // Slight delay so that we don't make the
                                    // next call to get more posts too
                                    // quickly.
                                    $timeout(function() {
                                        $scope.disableInfiniteScroll = false;
                                    }, 1000);
                                    _.each(posts, function(post) {
                                        // Add each post to the postsData
                                        // array so that they are appended to
                                        // the bottom of the posts div.
                                        $scope.postsData.push(post);
                                    });
                                }
                            });
                        }
                    };
                });

                // rollover lightbox for article preview

                $scope.lightBoxVisible = false;
                $scope.lightBoxData = false;
                $scope.lightBoxOver = false;
                $scope.$on('rolloverArticle', function(target, data) {
                    var dur = 500,
                        el = $('#posts_lightbox'),
                        container = $('.posts__lightbox__container', el),
                        backContent = $('#ui-state-holder'),
                        thumbs = $('.posts__content'),
                        isMobile = $(window).width() <= BREAKPOINTS.MOBILE,
                        scrollPercent;

                    if (!$scope.isSmall || currentState === 'home' || isMobile) {
                        $scope.lightBoxData = null;
                        el.hide();
                        return false;
                    }

                    if (data === false) {
                        $scope.lightBoxOver = false;

                        $timeout(function() {
                            if ($scope.lightBoxOver === false) {
                                thumbs.removeClass('zoom');
                                el.stop().animate({opacity: 0}, dur, function() {
                                    el.hide();
                                    $scope.lightBoxData = null;
                                });
                                container.removeClass('zoom');
                                backContent.removeClass('zoom');
                            }
                        }, 150);

                    } else {
                        $scope.lightBoxOver = true;

                        $timeout(function() {
                            // if the user is still over a thumbnail
                            if ($scope.lightBoxOver === true) {
                                scrollPercent = 100 * ($(window).scrollTop() / ($(document).height() - $(window).height()));

                                $scope.lightBoxData = data;
                                $scope.lightBoxData.summaryHTML = $sce.trustAsHtml(data.summary);

                                thumbs.addClass('zoom');

                                backContent.css({
                                    '-moz-transform-origin': '50% ' + scrollPercent + '%',
                                    'transform-origin':' 50% ' + scrollPercent + '%',
                                    '-ms-transform-origin':'50% ' + scrollPercent + '%',
                                    '-webkit-transform-origin':'50% ' + scrollPercent + '%'
                                });
                                backContent.addClass('zoom');
                                $timeout(function() {
                                    container.addClass('zoom');
                                }, 200);
                                el.stop().show().animate({opacity: 1}, dur);
                            }
                        }, 300);

                    }
                });

                $scope.windowpop = function(url, width, height) {
                    var leftPosition, topPosition;
                    //Allow for borders.
                    leftPosition = (window.screen.width / 2) - ((width / 2) + 10);
                    //Allow for title and status bars.
                    topPosition = (window.screen.height / 2) - ((height / 2) + 50);
                    //Open the window.
                    window.open(url, 'Window2', 'status=no,height=' + height + ',width=' + width + ',resizable=yes,left=' + leftPosition + ',top=' + topPosition + ',screenX=' + leftPosition + ',screenY=' + topPosition + ',toolbar=no,menubar=no,scrollbars=no,location=no,directories=no');
                    return false;
                };
            }
        };
    }])
;
